import { makeStyles } from '@mui/styles';

import CustomerProfileContainer from '@/views/Pages/Customer/CustomerProfile';
import { Entities, useDrawer } from '@/context/DrawerContext';

export const styles = makeStyles(theme => ({
  container: {
    width: 0,
    marginTop: 0,
    zIndex: 1000,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    transition: '225ms cubic-bezier(0, 0, 0.2, 1)',
    position: 'absolute',
    borderLeft: `1px solid ${theme.palette.divider}`,
    '&.expanded': {
      width: 960,
      maxWidth: '90%',
      height: '100vh'
    },
    '& > div': {
      padding: 0,
      overflowY: 'initial',
      '& > div': {
        padding: 0
      }
    }
  }
}));

const RightContentDrawer = () => {
  const classes = styles();

  const { drawerMode, isOpen, entity, id } = useDrawer();

  return (
    <div className={`${classes.container}${isOpen ? ' expanded' : ''}`}>
      {isOpen && entity == Entities.CUSTOMER && id && (
        <CustomerProfileContainer id={id} drawerMode={drawerMode} />
      )}
    </div>
  );
};
export default RightContentDrawer;
